export class HideTarget {
    constructor(optionalOptions = {}) {
        this._modalhideButtons = document.querySelectorAll('[data-action=\'hide\']');

        if (!this._modalhideButtons) {
            this.destructor();
            return true;
        }

        let target

        this._modalhideButtons.forEach((button) => {
            button.addEventListener("click", () => {
                if (!button.hasAttribute("data-target")) {
                    return false
                }

                target = button.dataset.target

                document.querySelector(target).style.display = 'none';
            })
        })
    }

    destructor() {
        this._modalhideButtons = null;
    }
}

export default new HideTarget();
